
<template>
  <div class="sidebar-item-group">
    <div class="sidebar-item" :class="{'sidebar-item--parent':props.item.children?.length}" @click="onClick">
      <ExpandIcon v-if="props.item.children?.length && !item.expand" size="16px" />
      <CollapseIcon v-if="props.item.children?.length && item.expand" size="16px" />
      <!-- spacer? -->
      <div :class="['app-ui-10', 'sidebar-label', {'sidebar-label--bold':level===0, 'sidebar-label--active':isActive}]">
        {{ props.item.text }}
      </div>
    </div>
    <div
      v-if="props.item.children?.length"
      v-show="props.item.expand"
      class="sidebar-children-wrapper"
    >
      <SidebarItem
        v-for="child, index in item.children"
        :key="`${props.item.key}-${child.key}`"
        :item="item.children[index]"
        :level="props.level + 1"
      />
    </div>
  </div>
</template>


<script setup>
import { useRoute, useRouter } from 'vue-router';
import { computed, defineEmits, onMounted, ref, watch } from 'vue';
import ExpandIcon from '@wholebodyapp/ui-components/src/components/icons/chevron-down/chevron-down.vue';
import CollapseIcon from '@wholebodyapp/ui-components/src/components/icons/chevron-up/chevron-up.vue';


const ITEM_HEIGHT = 32;

const emit = defineEmits(['update:item']);

//const isActive = ref(false);
// const isExpanded = ref(false);
const route = useRoute();
const router = useRouter();
const props = defineProps({
  item:       { type: Object,  required: true, },
  level:      { type: Number,  default: 0 },
});

const isActive = computed (() => {
  const slug = props?.item?.path?.match(/^[^?]*/);
  return slug?.[0] === route.path;
});

const myItem = computed({
  get () {
    return props.item;
  },
  set (newValue) {
    emit('update:item', newValue);
  }
});


function onClick () {
  if (props.item.path)
    router.push(props.item.path);
  else {
    myItem.value.expand = !myItem.value.expand;
  }
}

</script>


<style lang="scss">
@use '@wholebodyapp/design/colors/palette' as *;
@use '@wholebodyapp/design/typography/weights' as *;

$itemHeight: 32px;

.sidebar-item {
  align-items: center;
  display:flex;
  margin-left: 32px;
  color: var(--text-500);
  cursor: pointer;
  position: relative;
  padding-top: 8px;
}

.sidebar-item--parent {
  color: var(--text-900);
  gap: 8px;
  margin-left: 8px;
}

.sidebar-item .icon {
  color: $gray-300;
}

.sidebar-item--active {
  color: var(--primary-text);
}

.sidebar-item-label {
  padding: 8px;
}

.sidebar-label {
  padding: 4px;
  border-radius: 4px;
  width: 100%;
}


.sidebar-label--active {
  background: $primary-100;
  color: var(--on-primary-bg);
}

.app-ui-10.sidebar-label--bold {
  font-weight: $semibold;
}

.sidebar-icon {
  background: $gray-200;
  border: 3px solid $gray-300;
  border-radius: 9px;
  height: 16px;
  left: 8px;
  position: absolute;
  top: 4px;
  width: 16px;
}

.sidebar-bar {
  background: $gray-400;
  height: $itemHeight;
  width: 1px;
  left: 18px;
  position: absolute;
  top:0;
}

.sidebar-bar--active {
  background: $primary-500;
  left: 17px;
  width: 4px;
}

.sidebar-children-wrapper {
  border-left: 1px solid $gray-300;
  margin-left: 14px;
  padding-left: 8px;
}


</style>



